<template>
  <div class="OpenExpertViewLite">
    <div class="fix-top-section">
      <MobileNav></MobileNav>

      <LivePriceTickerVue></LivePriceTickerVue>
      <!-- Banner Image -->
      <div class="banner-section">
        <!-- <img v-if="currentEnvironment.utm_source == 'Supernal Ventures'" src="../assets/images/OfferBanner.svg" class="offer-img-mob" alt="" /> -->
        <ChatBannerComponent class="chat-banner banner-desktop"></ChatBannerComponent>
        <!-- <ChatBannerComponent class="banner-mobile chat-banner"></ChatBannerComponent> -->
      </div>
    </div>
    <OpenRecoCardLite></OpenRecoCardLite>

    <StockSectionCarousel></StockSectionCarousel>

    <SectorsCovered></SectorsCovered>

    <PremiumPlanSection></PremiumPlanSection>

    <RetailFooter class="footer"></RetailFooter>

    <div v-if="userProfile != null">
      <ProcessKycComponent :planDetails="planSubscriptionStatusDetails"></ProcessKycComponent>
    </div>
  </div>
</template>
  
  <script>
import RetailFooter from '@/components/RetailSideCompo/RetailFooter.vue';
import MobileNav from '@/components/MobileNav.vue';
import ChatBannerComponent from '@/components/ChatBannerComponent.vue';
import LivePriceTickerVue from '../components/LivePriceTicker.vue';
import OpenRecoCardLite from '../components/OpenRecoCardLite.vue';
import StockSectionCarousel from '../components/StockSectionCarousel.vue';
import SectorsCovered from '../components/SectorsCovered.vue';
// import LoginSectionComponent from '../components/loginSectionComponent.vue';
import PremiumPlanSection from '../components/PremiumPlanSection.vue';
import ProcessKycComponent from '@/components/NewKycFlow.vue';
import { serverAddr } from '../networkConfig';
import moment from 'moment';

export default {
  name: 'OpenExpertViewLite',
  components: { MobileNav, RetailFooter, ChatBannerComponent, LivePriceTickerVue, OpenRecoCardLite, StockSectionCarousel, SectorsCovered, PremiumPlanSection, ProcessKycComponent },

  data() {
    return {
      userProfile: {},
      planSubscriptionStatusDetails: null,
    };
  },

  mounted() {
    // Call getUserProfile initially
    this.getUserProfile();
  },

  methods: {
    getUserProfile() {
      this.is_profile_save_loading = true;

      serverAddr
        .get('/auth/v1/profile')
        .then(this.getProfileCallBack)
        .catch(function (error) {
          console.log(error);
        });

      // Store the current calling time in localStorage
      const currentTime = moment().format('YYYY-MM-DD HH:mm:ss');
      localStorage.setItem('lastProfileCall', currentTime);
    },
  },
  computed: {
    // Retrieves subscribed plan details from local storage
    subscribedPlanDetails() {
      return JSON.parse(localStorage.getItem('plan_details') || '{}'); // Ensures it's always an object
    },

    isPremiumPlan() {
      return this.subscribedPlanDetails && this.subscribedPlanDetails.plan === 'Premium';
    },
  },

  beforeRouteEnter(to, from, next) {
    const planDetails = JSON.parse(localStorage.getItem('plan_details') || '{}'); // Ensure object structure
    if (planDetails && planDetails.plan === 'Premium') {
      next('/data-categorisation'); // Redirect if user has Premium plan
    } else {
      next(); // Continue with the navigation
    }
  },

  beforeRouteUpdate(to, from, next) {
    if (this.isPremiumPlan) {
      next('/data-categorisation'); // Redirect if user has Premium plan
    } else {
      next();
    }
  },
};
</script>
  
<style scoped lang="scss">
.OpenExpertViewLite {
  background-color: #f4f4f4;
  .fix-top-section {
    margin-bottom: 80px;
    position: relative;
    z-index: 10;
  }
  .chat-banner {
    position: relative;
    top: 99px;
    z-index: 0;
  }
  // .footer {
  //   padding-top: 60px;
  // }

  .banner-mobile {
    display: none;
  }

  @media screen and (max-width: 727px) {
    .banner-mobile {
      display: block;
      margin-bottom: 15px;
    }
  }
}
</style>
<style  lang="scss">
.OpenExpertViewLite {
  .footer-container {
    margin-top: 0 !important;
  }
}
</style>